import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import HeaderB from "@/components/HeaderB";
import HeroB from "@/components/HeroB";
import Benefits from "@/components/Benefits";
import Package from "@/components/Package";
import ForWhom from "@/components/ForWhom";
import Differentials from "@/components/Differentials";
import HowItWorks from "@/components/HowItWorks";
import FAQ from "@/components/FAQ";
import CheckoutB from "@/components/CheckoutB";
import Footer from "@/components/Footer";
import StickyMobileCTAB from "@/components/StickyMobileCTAB";

const IndexB = () => {
  useEffect(() => {
    Sentry.setTag('ab_variant', 'B');
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: 'Page view: Variant B',
      level: 'info',
    });
  }, []);

  return (
    <div className="min-h-screen">
      <HeaderB />
      <main>
        <HeroB />
        <Benefits />
        <Package />
        <ForWhom />
        <Differentials />
        <HowItWorks />
        <FAQ />
        <CheckoutB />
      </main>
      <Footer />
      <StickyMobileCTAB />
    </div>
  );
};

export default IndexB;
